import { render, staticRenderFns } from "./PolicyRisk.vue?vue&type=template&id=89448914&"
import script from "./PolicyRisk.vue?vue&type=script&lang=js&"
export * from "./PolicyRisk.vue?vue&type=script&lang=js&"
import style0 from "./PolicyRisk.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports